export default __webpack_public_path__ + "static/media/amlogo.8e58f1cc.png";